import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** shadcn/ui 標準のクラス結合ヘルパー */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
